import React, { Component } from "react";
import { connect } from "react-redux";
import { postComment } from "../../actions/approvalCommentsActions";
import { createComment } from "../../actions/commentActions";
import { withRouter } from "react-router-dom";
import { Row, Col, Button, Form, Image } from "react-bootstrap";
import CanvasDraw from "react-canvas-draw";
import axios from "axios";
import { css } from "@emotion/core";
import ReactQuill from "react-quill"; // ES6
import "react-quill/dist/quill.snow.css"; // ES6
import { API_ENDPOINT, UPLOAD_ENDPOINT } from "../../secrets";
import SyncLoader from "react-spinners/SyncLoader";
const spinnerStyle = css`
    margin-left: 50%;
    transform: translate(-50%, 0);
`;
class CommentTile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cols: 1,
            showTextInput: false,
            nImgs: 0,
            imgs: [],
            tag: "",
            inputText: "",
            clientWidth: 100,
        };
        this.commentImage = React.createRef();
    }

    componentDidMount() {
        if (this.divElement) {
            this.setState({ clientWidth: this.divElement.clientWidth });
        }
    }

    getCols = () => {
        if (this.state.cols >= 4) {
            return 4;
        } else {
            return this.state.cols;
        }
    };

    submit = () => {
        let data = {
            canvas_id: this.props.canvas._id,
            user: this.props.user.id,
            comment_text: this.state.inputText,
            comment_image_uploads: this.state.imgs.map((upload) => upload.id),
            tag: this.state.tag
        };

        if (this.props.replyTo) {
            data["data_linked"] = this.props.replyTo;
        }

        if (this.state.inputText !== "" || this.state.imgs.length !== 0) {
            // if(this.props.canvas.version==='GOOGLE'){
            //     this.props.postComment(data);
            // }
            // else{
                this.props.createComment(data);
            // }
            this.props.clearReplyTo();
            this.setState({
                cols: 1,
                showTextInput: false,
                nImgs: 0,
                imgs: [],
                inputText: "",
            });
        } else {
            //Post an error
        }
    }

    handleSubmit = (e) => {

        if(this.commentImage.current.files[0]){

            this.uploadImage()
            .then(()=> {
                this.submit()    
            }).catch(() => {
                // post error
            })
        }else{
            this.submit()
        }

        
    };

    addTextBox = (e) => {
        e.preventDefault();
        this.setState({ cols: this.state.cols + 1, showTextInput: true });
    };

    handleImageUpload = (e) => {
        e.preventDefault()

        let { current } = this.commentImage

        if(current.files){

            for(let i = 0; i < current.files.length; i++){
                let reader = new FileReader()

                reader.onload = (e) => {
                    this.addImageBox({
                        link: e.target.result
                    })
                }
                reader.readAsDataURL(current.files[i])
            }
            
        }

    }

    uploadSingleImage = (file) => {
        const formData = new FormData();
        formData.append("file", file, file.name);
        formData.append("tag", "") // NOTE REMOVE REQ FOR TAG ON UPLOAD SERVICE
        formData.append("canvas_id", this.props.canvas._id)
        formData.append("client_id", this.props.canvas.client)
        const UPLOAD_FILE_DATA_URI = UPLOAD_ENDPOINT
        this.props.setLoading(true);
        this.setState({ isImageUploading: true });
        return axios
            .post(UPLOAD_FILE_DATA_URI, formData, { crossDomain: true })
            .then((response) => {
                this.addImageBox(response.data);
                this.props.setLoading(false);
                return Promise.resolve()
                
            })
            .catch((e) => {
                this.props.setLoading(false);
                console.log(e.message);
                return Promise.reject()
            });
    }

    uploadImage = () => {
        
        let files = this.commentImage.current.files;
        let filePromises = []

        if(files.length > 0){
            return new Promise((resolve, reject) => {
                this.setState({
                    imgs: this.state.imgs.slice(0, -1*files.length),
                    cols: this.state.cols-files.length,
                    nImgs: this.state.nImgs-files.length
                }, () => {
                    for(let i = 0; i < files.length; i++){
                        filePromises.push(this.uploadSingleImage(files[i]))
                    }
    
                    resolve(Promise.all(filePromises))
                })
            })
            
        }else{
            return Promise.resolve();
        }

        

        
        
        
    };

    // uploadImage = (e) =>
    // {
    //     e.preventDefault()
    //     //TODO: Upload the image and get the url
    //     this.addImageBox("https://via.placeholder.com/450")
    // }

    addImageBox = (upload) => {
        let nImgs = this.state.nImgs + 1;
        let imgs = [...this.state.imgs, upload];
        this.setState({ nImgs, imgs, cols: this.state.cols + 1 });
    };

    renderImageBox = (upload) => {
        let cols = this.getCols();

        if (this.props.replyTo !== undefined) {
            cols = cols + 1;
        }

        return (
            <Col
                xs={12}
                md={cols < 2 ? 12 / cols : 6}
                lg={cols < 4 ? 12 / cols : 4}
                xl={12 / cols}
                style={{
                    minHeight: "300px",
                    padding: "0",
                    backgroundColor: "white",
                }}
            >
                <Image src={upload.link} fluid></Image>
            </Col>
        );
    };

    handleTextChange = (e) => {
        this.setState({ inputText: e });
    };

    handleTagChange = (e) => {
        this.setState({
            tag: e.target.value
        })
    }

    renderUserProfile = () => {
        let render = null;
        try {
            let name = "Anonymous";
            if (this.props.user && this.props.user.email) {
                name = this.props.user.email.split("@")[0];
            }

            if (this.props.user && this.props.user.name) {
                name = this.props.user.name;
            }
            // let name = (this.props.user.name !== undefined && this.props.user.name !== '')? this.props.user.name : this.props.user.email.split('@')[0]
            let profile_pic = this.props.user.profile_pic;
            let diff = "Just now";

            render = (
                <Col xs={12} className="user-profile">
                    <Row>
                        <Image src={profile_pic}></Image>
                        <Col xs={10}>
                            <p className="name">{name}</p>
                            <p className="time">{diff}</p>
                        </Col>
                    </Row>
                </Col>
            );
        } catch (error) {
            console.log(error);
            render = <p>{this.props.user.email}</p>;
        }
        return render;
    };

    renderContent = () => {
        let render;
        switch (this.props.contentType) {
            case "TEXT":
                render = <p>{this.props.text}</p>;
                break;
            case "IMAGE":
                render = <Image src={this.props.image}></Image>;
                break;
            case "ANSWER":
                render = (
                    <Col xs={12}>
                        <h5 style={{ textAlign: "center" }}>
                            {this.props.data.question !== null &&
                                this.props.data.question.main}
                        </h5>
                        <Row className="justify-content-md-center">
                            {this.props.data.options.map((option) => (
                                <Col
                                    key={option.text + option.link}
                                    xs={6}
                                    lg={6}
                                >
                                    <Image src={option.link} fluid></Image>
                                    <p className="option-text">{option.text}</p>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                );
                break;
            case "TEXT_MOODBOARD":
                render = (
                    <Col xs={12}>
                        <h5 style={{ textAlign: "center" }}>Furniture Style</h5>
                        <Row className="justify-content-md-center">
                            {this.props.data.options.map((option) => (
                                <Col key={option} xs={6}>
                                    <p className="option-text">{option}</p>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                );
                break;
            case "VISUAL_MOODBOARD":
                render = (
                    <Col xs={12}>
                        <Image src={this.props.data} fluid></Image>
                    </Col>
                );
                break;

            case "UPLOAD":
                render = (
                    <Col xs={12}>
                        <Image src={this.props.data.link}></Image>
                    </Col>
                );
                break;
            case "SKETCH":
                render = (
                    <Col
                        xs={12}
                        ref={(divElement) => (this.divElement = divElement)}
                        style={{ minHeight: "100%" }}
                    >
                        <CanvasDraw
                            className="canvas-sketch"
                            disabled
                            canvasWidth={this.state.clientWidth}
                            canvasHeight={this.state.clientWidth}
                            ref={(canvasDraw) =>
                                (this.loadableCanvas = canvasDraw)
                            }
                            saveData={this.props.data.sketchData}
                        />
                    </Col>
                );
                break;
            default:
                break;
        }
        return render;
    };

    renderReplyTo = () => {
        let cols = this.getCols();

        if (this.props.replyTo !== undefined) {
            cols = cols + 1;
        }

        let render = <div></div>;
        try {
            let replyTo = this.props.replyTo;
            console.log(replyTo);

            switch (replyTo.type) {
                case "SKETCH":
                    render = (
                        <Col
                            xs={12}
                            md={cols < 2 ? 12 / cols : 6}
                            lg={cols < 4 ? 12 / cols : 4}
                            xl={12 / cols}
                            className={this.state.className + " reply-to"}
                        >
                            <h6>Replying to</h6>
                            <Col xs={12} className="canvas-tile">
                                <Row>
                                    <Col
                                        xs={12}
                                        ref={(divElement) =>
                                            (this.divElement = divElement)
                                        }
                                        style={{ minHeight: "100%" }}
                                    >
                                        <CanvasDraw
                                            className="canvas-sketch"
                                            disabled
                                            canvasWidth={this.state.clientWidth}
                                            canvasHeight={
                                                this.state.clientWidth
                                            }
                                            ref={(canvasDraw) =>
                                                (this.loadableCanvas = canvasDraw)
                                            }
                                            saveData={replyTo.image}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Col>
                    );
                    break;
                case "IMAGE":
                    render = (
                        <Col
                            xs={12}
                            md={cols < 2 ? 12 / cols : 6}
                            lg={cols < 4 ? 12 / cols : 4}
                            xl={12 / cols}
                            className={this.state.className + " reply-to"}
                        >
                            <h6>Replying to</h6>
                            <Col xs={12} className="canvas-tile">
                                <Row>
                                    <Image src={replyTo.image} fluid></Image>
                                </Row>
                            </Col>
                        </Col>
                    );
                    break;
                case "TEXT_IMG":
                    render = (
                        <Col
                            xs={12}
                            md={cols < 2 ? 12 / cols : 6}
                            lg={cols < 4 ? 12 / cols : 4}
                            xl={12 / cols}
                            className={this.state.className + " reply-to"}
                        >
                            <h6>Replying to</h6>
                            <Col xs={12} className="canvas-tile">
                                <Row>
                                    <Col xs={12}>
                                        <h5 style={{ textAlign: "center" }}>
                                            {replyTo.text}
                                        </h5>
                                        <Image
                                            src={replyTo.image}
                                            style={{ filter: "invert(1)" }}
                                            fluid
                                        ></Image>
                                    </Col>
                                </Row>
                            </Col>
                        </Col>
                    );
                    break;
                case "TEXT":
                    render = (
                        <Col
                            xs={12}
                            md={cols < 2 ? 12 / cols : 6}
                            lg={cols < 4 ? 12 / cols : 4}
                            xl={12 / cols}
                            className={this.state.className + " reply-to"}
                        >
                            <h6>Replying to</h6>
                            <Col xs={12} className="canvas-tile">
                                <Row>
                                    <Col xs={12}>
                                        <h5 style={{ textAlign: "center" }}>
                                            {replyTo.text}
                                        </h5>
                                    </Col>
                                </Row>
                            </Col>
                        </Col>
                    );
                    break;
                default:
                    render = <div></div>;
            }
        } catch (error) {
            render = <div></div>;
        }

        return render;
    };

    render() {
        let cols = this.getCols();
        let replyTo = this.props.replyTo;

        if (this.props.replyTo === undefined) {
            replyTo = <div></div>;
        } else {
            replyTo = this.renderReplyTo();
            cols = cols + 1;
        }

        let render = (
            <Col
                xs={12}
                md={cols * 6}
                lg={cols * 4}
                xl={cols * 3}
                style={{ padding: "0.5rem" }}
            >
                <Col xs={12}>{this.renderUserProfile()}</Col>
                <Col xs={12} className="comment-tile">
                    <Row>
                        <Col
                            xs={12}
                            md={cols < 2 ? 12 / cols : 6}
                            lg={cols < 4 ? 12 / cols : 4}
                            xl={12 / cols}
                            className="add-content-tile"
                        >
                            <Row>
                                <Col xs={{ span: 12 }}>
                                    <Button
                                        onClick={() =>
                                            this.props.history.push("/login")
                                        }
                                    >
                                        Login
                                    </Button>
                                </Col>
                                <Col xs={{ span: 12 }}>
                                    <Button
                                        onClick={() =>
                                            this.props.history.push("/login")
                                        }
                                    >
                                        Sign Up
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Col>
        );

        if (this.props.user && this.props.user.email) {
            render = (
                <Col
                    xs={12}
                    md={cols * 6}
                    lg={cols * 4}
                    xl={cols * 3}
                    style={{ padding: "0.5rem" }}
                >
                    <Col xs={12}>{this.renderUserProfile()}</Col>
                    <Col xs={12} className="comment-tile">
                        <Row>
                            {replyTo}
                            {this.state.showTextInput && (
                                <Col
                                    xs={12}
                                    md={cols < 2 ? 12 / cols : 6}
                                    lg={cols < 4 ? 12 / cols : 4}
                                    xl={12 / cols}
                                    style={{
                                        minHeight: "300px",
                                        backgroundColor: "white",
                                        paddingLeft: "0px",
                                        paddingRight: "0px",
                                    }}
                                >
                                    {/* <Form.Control as="textarea" 
                                        rows="3"  
                                        style={{"height": "100%", "fontSize":"2rem", "border": "none", "outline": "none"}} 
                                        placeholder="Describe your thought in words here..." 
                                        value={this.state.inputText} 
                                        onChange={this.handleTextChange}/> */}
                                    <ReactQuill
                                        value={this.state.inputText}
                                        style={{
                                            height: "100%",
                                            fontSize: "1rem",
                                            border: "none",
                                            outline: "none",
                                        }}
                                        onChange={this.handleTextChange}
                                    />
                                </Col>
                            )}

                            {this.state.nImgs > 0 &&
                                this.state.imgs.map((img) =>
                                    this.renderImageBox(img)
                                )}

                            <Col
                                xs={12}
                                md={cols < 2 ? 12 / cols : 6}
                                lg={cols < 4 ? 12 / cols : 4}
                                xl={12 / cols}
                                className="add-content-tile"
                            >
                                <Row>
                                    <Col xs={{ span: 12 }}>
                                        <Button onClick={this.addTextBox}>
                                            Add Text
                                        </Button>
                                    </Col>
                                    <Col xs={{ span: 12 }}>
                                        <Button>
                                            <label
                                                htmlFor="comment-image"
                                                className="profile-pic-wrapper"
                                            >
                                                {this.props.uploading ? (
                                                    <SyncLoader
                                                        css={spinnerStyle}
                                                        color={"#000000"}
                                                        sizeUnit={"em"}
                                                        size={"1"}
                                                    ></SyncLoader>
                                                ) : (
                                                    "Upload Images"
                                                )}
                                                <Form.Control
                                                    type="file"
                                                    ref={this.commentImage}
                                                    onChange={
                                                        this.handleImageUpload
                                                    }
                                                    id="comment-image"
                                                    style={{
                                                        visibility: "hidden",
                                                        position: "absolute",
                                                    }}
                                                    multiple
                                                ></Form.Control>
                                            </label>
                                        </Button>
                                    </Col>
                                    <Col xs={{ span: 12 }}>
                                        <Form.Control as="select" custom className="tag-select" onChange={this.handleTagChange}>
                                            <option selected disabled>Choose image tag</option>
                                            <option>SKETCH</option>
                                            <option>WHITE_MODEL</option>
                                            <option>MCF</option>
                                        </Form.Control>       
                                    </Col>
                                    <Col xs={{ span: 12 }}>
                                        <Button
                                            ref={(ref) =>
                                                this.props.getRef(ref)
                                            }
                                            onClick={this.handleSubmit}
                                            style={{
                                                backgroundColor: "black",
                                                color: "white",
                                            }}
                                        >
                                            Post
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Col>
            );
        }

        return render;
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        canvas: state.canvas[localStorage.getItem("nayaCanvasId")],
        uploading: state.loading.uploading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        postComment: (data) => dispatch(postComment(data)),
        createComment: (data) => dispatch(createComment(data)),
        setLoading: (state) =>
            dispatch({ type: "SET_LOADING", key: "uploading", value: state }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CommentTile));
